<template>
	<div style="padding-bottom: 50px;">
		<!--<p>{{slipDatas[statusCode].context}} </p>-->
		<!--<div class="j-describe">
            	<span> 很抱歉！您还没有注册任何企业码标，不能注册品类码标，现在去</span>
            	<el-button type="primary" round size="mini">注册企业码标</el-button>
            </div>-->
		<div class="introduce">
			<h2 class="inTit">企业码标与品类码标说明</h2>
			<div class="issue-box">
				<p class="t format">理解什么是品类码标？请先看以下为完整码标应用于一物一码或一品一码或一批一码样例结构图：</p>
				<img src="../assets/imgs/Genren.png" style="margin-top: 20px;" />

			</div>

		</div>
		<div class="introduce ">
			<!--<h2 class="inTit ">企业根节点树标识</h2>-->
			<div class="issue-box f-cb">
				<p class="f-fl tit">企业码标 : </p>
				<div class="f-fl affiliate">
					<p class="t format">码标平台为企业分配的唯一企业根节点标识. </p>
					<p class="t format"> 例如：MA.haier，其中MA是码标开始标识符节点，haier为海尔集团的企业码标，企业码标通常注册企业LOGO关键标识符号或商标或企业品 牌名称等。例如：huawei是华为的企业码标。
					</p>
					<!--<p class="t format"> 企业码标通常注册企业LOGO关键标识符号或商标或企业品牌名称等。</p>-->
					<!--<p class="t format">例如：huawei是华为的企业码标。</p>-->
				</div>

			</div>
			<div class="issue-box">
				<p class="f-fl tit">品类码标：</p>
				<div class="f-fl affiliate">
					<p class="t format">指企业产品或对类目的标识符，通常指产品型号名称或型号代码等。</p>
					<p class="t format"> 例如：Casrte30 是海尔某个产品的型号代码。品类码标完整编码：MA.haier/Casrte30</p>
					<p class="t format"> 例如：P30 是华为公司给手机型号P30的产品代码。品类完整代码：MA.huawei/P30</p>
					<p class="t format">例如：P30 是华为公司给手机型号P30的产品代码。品类完整代码：MA.huawei/P30</p>
					<div class="issue-box">
						<p class="t format">如果是一品一码则用：MA.huawei/P30 ，表示P30这个品类的码</p>
						<p class="t format"> 例如：Casrte30 是海尔某个产品的型号代码。品类码标完整编码：MA.haier/Casrte30</p>
						<p class="t format"> 如果是 一批一码则用：MA.huawei/P30/2019052201，表示P30这个品类的生产批次号为2019052201的批次码。</p>
						<p class="t format">如果是 一物一码则用：MA.huawei/P30/2019052201.1000008，表示P30这个品类的生产批次号为2019052201的 某手机的流水号为1000008

						</p>

					</div>
				</div>
			</div>
		
		</div>
	<p class="remind">注册购买企业码标后，基于企业码标扩展的品类码标注册是免费的，可以无限制注册品类码标.</p>
	</div>
</template>

<script>
	import jDescribe from '@/components/jurisdictionDescribe.vue';

	export default {
		components: {
			jDescribe

		},
		data() {
			return {
				slipDatas: {
					'503': {
						context: '您还没有注册码标或您注册的码标正在审核，暂不能注册品类码标',
						router: 'perfect'
					},
					'5': {
						context: '个人用户暂不支持此功能',
					}
				}
			}
		},
		props: ['statusCode'],
		mounted() {
			this.$store.commit('resistopen')
			
		},
		computed: {

		},
		beforeDestroy() {
			this.$store.commit('resistDestroy')
//			console.log(this.$store.state.resistshow )
			
		},

	}
</script>

<style lang="scss">
	$introduce-w: 1020px;
	.introduce {
		width: $introduce-w;
		display: inline-block;
		margin-top: 40px;
		/*border: solid red 1px;*/
		text-align: center;
		.inTit {
			font-size: 20px;
			color: #434343;
			display: inline-block;
			font-weight: 500;
			padding-bottom: 18px;
			border-bottom: solid #007ee5 2px;
		}
		.issue-box {
			margin-top: 40px;
			
			text-align: left;
			.tit {
				width: 100px;
				font-weight: 600;
				font-size: 16px;
				display: inline-block;
				/*border: solid red 1px;*/
			}
			.affiliate {
				display: inline-block;
				/*border: solid red 1px;*/
				width: $introduce-w - 100px;
			}
			.format {
				font-family: "微软雅黑";
				color: #333;
				font-size: 15px;
				margin-bottom: 16px;
				/*margin;*/
				margin-top: 0;
				line-height: 150%;
			}
		}
	}
	
	.remind {
		width: $introduce-w;
		display: inline-block;
		text-align: left;
		/*padding: 10px 0;*/
		padding-top: 40px;
		font-size: 15px;
		color: red;
	}
</style>